import RetrieveProfile from './RetrieveProfile';

export default RetrieveProfile;
